module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isBlank) ? _c('div', {
    staticClass: "content-block"
  }) : _c('div', {
    staticClass: "content-block",
    class: {
      'underline': _vm.hasUnderLine
    }
  }, [_c('div', {
    staticClass: "block-top"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('div', {
    staticClass: "label-name"
  }, [_vm._v(_vm._s(_vm.labelName))]), _vm._v(" "), _c('div', {
    staticClass: "label-no"
  }, [_vm._v(_vm._s(_vm.labelNo))])]), _vm._v(" "), (_vm.illustration) ? _c('div', {
    staticClass: "illustration"
  }, [_c('img', {
    attrs: {
      "src": _vm.illustration
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "en-title"
  }, [_vm._v(_vm._s(_vm.enTitle))]), _vm._v(" "), _c('div', {
    staticClass: "cn-title"
  }, [_vm._v(_vm._s(_vm.cnTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.contentImg) ? _c('div', {
    staticClass: "content-img"
  }, [_c('div', {
    staticClass: "imgbox"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: ("url(" + _vm.contentImg + ")")
    })
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-text"
  }, [_vm._v(_vm._s(_vm.contentText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8365e4aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/source/ContentBlock.vue
// module id = 682
// module chunks = 0